<div class="dialog">
    <div class="dialog-header">编辑</div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 交工检测标段
                </div>
                <div class="column {{!!record.jgSectionId ? 'color-primary' : 'color-danger'}}"
                    [style.width]="120 + 'px'">
                    <select [(ngModel)]="record.jgSectionId" (ngModelChange)="onSectionChange()">
                        <option [value]="undefined" disabled>选择类型</option>
                        <option *ngFor="let item of sectionList" [value]="item.id">{{item.name}}
                        </option>
                    </select>
                </div>
                <div class="column text-left background-module" [style.width]="440 + 'px'">
                    {{orgDisplay}}
                </div>
            </div>
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 交工检测类型
                </div>
                <div class="column" [style.width]="560 + 'px'">
                    <nz-checkbox-group [(ngModel)]="checkList"></nz-checkbox-group>
                </div>
            </div>

            <div class="row">
                <div class="column background-page text-right" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 方案文件
                </div>
                <div class="column" [style.width]="560 + 'px'">
                    <file-preview-entry (fileResponseChange)="onFileChange($event)" [fileType]="fileType"
                        [fileList]="fileUrls ?? []" [limit]="1" [required]="true">
                    </file-preview-entry>
                </div>
            </div>
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="100 + 'px'">
                    <span class="color-danger">*</span> 方案名称
                </div>
                <div class="column" [style.width]="560 + 'px'">
                    <input type="text" [(ngModel)]="record.name" [placeholder]="'输入检测方案名称'">
                </div>
            </div>

            <div class="row">
                <div class="column background-page text-right" [style.width]="100 + 'px'">
                    备注
                </div>
                <div class="column" [style.width]="560 + 'px'">
                    <input type="text" [(ngModel)]="record.comment" placeholder="输入备注信息">
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>